import { Component, EventEmitter, Input, Output } from "@angular/core";
import { GetProjectInvoiceProposalsList } from "../../../../core/models/orders/getInvoicebySalesOrderIdResponseDto.dto";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";

@Component({
  selector: "jni-invoice-preview-list-dailog",
  templateUrl: "./invoice-preview-list-dailog.component.html",
  styleUrls: ["./invoice-preview-list-dailog.component.scss"],
  imports: [DialogModule, TableModule, CommonModule, SpinnerComponent],
})
export class InvoicePreviewListDailogComponent {
  @Input() displayModal!: boolean;
  @Input() projectInvoicesProposalList = [] as GetProjectInvoiceProposalsList[];
  @Input() showSmallLoader = false;
  @Output() closeDialogEvent = new EventEmitter();

  closeModalDialog() {
    this.closeDialogEvent.emit();
  }

  redirectToIPSummary(proposalId: string) {
    if (proposalId) {
      const url = `invoice-preview/invoice-preview-summary/${proposalId}`;
      window.open(url);
    }
  }
}
